var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drawn-numbers-box",class:{ retail: _vm.retail },style:({justifyContent: _vm.bonus ? 'space-between' : 'center'})},[_c('DrawnNumbers',{attrs:{"numbers":_vm.drawnResults || [],"draw-starting":_vm.drawStarting,"is-retail":_vm.retail,"max":_vm.maxRegular}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }